// components/RightPart.jsx
import '../../../style.css';
import React, { useEffect, useMemo, useRef, useState } from "react";

// ======================
// RIGHT PART
// ======================
export default function RightPart({
  poolValues,
  selectedPoolIndex,
  setSelectedPoolIndex,
  onPlace,
  state,
}) {
  const [usedIndexes, setUsedIndexes] = useState({});
  const [dragValue, setDragValue] = useState(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [dragPos, setDragPos] = useState(null);

  const containerRef = useRef(null);

  // ======================
  // SELECT POOL ITEM (tap like iOS)
  // ======================
  const handleSelect = (index) => {
    if (usedIndexes[index]) return;

    setSelectedPoolIndex((prev) =>
      prev === index ? null : index
    );
  };

  // ======================
  // PLACE ON SLOT (called from LeftPart via parent)
  // ======================
  useEffect(() => {
    if (selectedPoolIndex == null) return;
  }, [selectedPoolIndex]);

  // ======================
  // DRAG START
  // ======================
  const handleDragStart = (e, value, index) => {
    if (usedIndexes[index]) return;

    setDragValue(value);
    setDragIndex(index);
  };

  // ======================
  // DRAG MOVE
  // ======================
  const handleDragMove = (e) => {
    if (!dragValue) return;

    setDragPos({
      x: e.clientX,
      y: e.clientY,
    });
  };

  // ======================
  // DROP
  // ======================
  const handleDrop = (e) => {
    if (!dragValue) return;

    const elements = document.elementsFromPoint(
      e.clientX,
      e.clientY
    );

    const slotEl = elements.find((el) =>
      el.dataset && el.dataset.slot
    );

    if (slotEl) {
      const key = slotEl.dataset.slot;

      // call parent logic
      onPlace?.(key, dragIndex);

      setUsedIndexes((prev) => ({
        ...prev,
        [dragIndex]: true,
      }));
    }

    setDragValue(null);
    setDragIndex(null);
    setDragPos(null);
  };

  // ======================
  // GLOBAL LISTENERS (like iOS gesture system)
  // ======================
  useEffect(() => {
    window.addEventListener("mousemove", handleDragMove);
    window.addEventListener("mouseup", handleDrop);

    return () => {
      window.removeEventListener("mousemove", handleDragMove);
      window.removeEventListener("mouseup", handleDrop);
    };
  });

  // ======================
  // RENDER CELL
  // ======================
  const renderCell = (value, index) => {
    const isUsed = usedIndexes[index];
    const isSelected = selectedPoolIndex === index;

    return (
      <div
        key={index}
        onClick={() => handleSelect(index)}
        onMouseDown={(e) =>
          handleDragStart(e, value, index)
        }
        className={`
        w-[20px] h-[20px] sm:w-[24px] sm:h-[24px] sm:w-[26px] sm:h-[26px]
           ${state ? "xl:w-[44px] xl:h-[44px] lg:w-[36px] lg:h-[36px] md:w-[28px] md:h-[28px]" : "xl:w-[52px] xl:h-[52px] lg:w-[50px] lg:h-[50px] md:w-[36px] md:h-[36px]"}
          flex items-center justify-center
          rounded-[4px] sm:rounded-[6px] lg:rounded-[10px]
          font-bold text-[14px] sm:text-[16px] lg:text-[20px]
          select-none
          transition-all duration-200
          ${
            isUsed
              ? "bg-gray-300 text-gray-500 pointer-events-none"
              : isSelected
              ? "bg-[#4771B5] text-white"
              : "bg-[#809FD2] text-white"
          }
        `}
      >
        {value}
      </div>
    );
  };

  // ======================
  // RENDER
  // ======================
  return (
    <div
      ref={containerRef}
      className={`${state ? "rightpartIsStateWidth" : "rightpartIsNotStateWidth"} z-[50] flex flex-col items-center h-full border-[3px] rounded-[16px] lg:rounded-[20px] border-[#7648B5] bg-[#FFF]`}
    >
      {/* GRID */}
      <div className="flex flex-col justify-evenly flex-1 w-full ">
  {Array.from({ length: Math.ceil(poolValues.length / 2) }).map((_, row) => (
    <div key={row} className="flex justify-evenly">
      {poolValues.slice(row * 2, row * 2 + 2).map((v, i) =>
        renderCell(v, row * 2 + i)
      )}
    </div>
  ))}
</div>

      {/* DRAG PREVIEW */}
      {dragValue != null && dragPos && (
        <div
          className="
            fixed
            w-[50px] h-[50px]
            flex items-center justify-center
            bg-[#4771B5]
            text-white font-bold
            rounded-[10px]
            pointer-events-none
            z-[9999]
          "
          style={{
            left: dragPos.x + 10,
            top: dragPos.y + 10,
          }}
        >
          {dragValue}
        </div>
      )}
    </div>
  );
}